
import {api} from "../../config";
/*
|--------------------------------------------------------------------------
| Mutation Types
|--------------------------------------------------------------------------
*/
export const SET_USER = 'SET_USER';
export const UPDATE_USER = 'UPDATE_USER';
export const UNSET_USER = 'UNSET_USER';

/*
|--------------------------------------------------------------------------
| Initial State
|--------------------------------------------------------------------------
*/
const initialState = {
  user: null
};

/*
|--------------------------------------------------------------------------
| Mutations
|--------------------------------------------------------------------------
*/
const mutations = {
  [SET_USER](state, payload) {
    state.user = payload.user;
    sessionStorage.setItem("authuser", JSON.stringify(payload.user));
  },
  [UPDATE_USER](state, payload) {
    let authUser = JSON.parse(sessionStorage.getItem("authuser")|| "null");
    let updKeys = Object.keys(payload.user)
    if(updKeys.length) {
      for(let kId of updKeys) {
        if(payload.user[kId] != authUser[kId]) {
            authUser[kId] = payload.user[kId];
        }
      }
      state.user = authUser;
      sessionStorage.setItem("authuser", JSON.stringify(authUser));
    }
  },
  [UNSET_USER](state) {
    state.user = null;
    sessionStorage.removeItem("authuser");
  }
};

/*
|--------------------------------------------------------------------------
| Actions
|--------------------------------------------------------------------------
*/
const actions = {
  setAuthUser: (state, user) => {
    state.commit(SET_USER, {user})
  },
  updateAuthUser: (state, user) => {
    state.commit(UPDATE_USER, {user})
  },
  unsetAuthUser: (state) => {
    state.commit(UNSET_USER);
  },
  currentAuthUser: (state) => {
    axios.get(api.currentUser)
      .then((resp) => {
          let user = resp.data
          state.commit(SET_USER, {user})
      }).catch(err => {
          state.commit(UNSET_USER, {user})
      });
  }
};

/*
|--------------------------------------------------------------------------
| Getters
|--------------------------------------------------------------------------
*/
const getters = {
  getAuthUser: (state, user) => {
    return state.user
  },
};

/*
|--------------------------------------------------------------------------
| Export the module
|--------------------------------------------------------------------------
*/
export default {
  state: initialState,
  mutations,
  actions,
  getters
}